import React, { useContext } from "react";
import { createPortal } from 'react-dom';
import { Routes, Route, useLocation } from "react-router-dom";
import Sidebar from "./Components/Sidebar";
import NavBar from "./Components/NavBar";
import { Context } from "./Context/Context";
import ProtectedRoutes from "./Components/ProtectedRoutes";
import HomeRoot from "./Pages/HomeRoot2";
import RedirectVerifiedUsers from "./Components/RedirectVerifiedUsers";
import PublicRoute from "./Components/PublicRoute";
import AboutUs from "./Pages/AboutUs";
import HowItWorks from "./Pages/HowItWorks";
import Dashboard from "./Pages/Dashboard";
import Home from "./Pages/Home";
import Beneficiary from "./Pages/Beneficiary";
import Invoice from "./Pages/Invoice";
import Transaction from "./Pages/Transaction";
import Settings from "./Pages/Settings";
import SMSideBar from "./Components/SMSideBar";
import LoadingScreen from "./Pages/LoadingScreen";
import ExternalInvoice1 from "./Pages/ExternalInvoice1";
import NotFound from "./Pages/NotFound";
import UseCases from "./Pages/UseCases";
import ValidateOTP from "./Pages/ValidateOTP";

const SignUp = React.lazy(() => import('./Pages/SignUp'));
const Login = React.lazy(() => import('./Pages/Login'));
const ForgotPassword = React.lazy(() => import('./Pages/ForgotPassword'));
const UpdatePassword = React.lazy(() => import('./Pages/UpdatePassword'));

function App() {
  const { handleSideBar, sideBar, isDataLoaded, showPDFContent } = useContext(Context);
  const location = useLocation();

  const UserProfile = JSON.parse(localStorage.getItem('UserProfile'));
  const NumberOfUserAcct = parseInt(localStorage.getItem('NumberOfUserAcct'), 10);
  const UserAcctDetails = localStorage.getItem('UserAcctDetails');
  const NumberOfBeneficiaryAcct = parseInt(localStorage.getItem('NumberOfBeneficiaryAcct'), 10);
  const NumberOfInvoices = parseInt(localStorage.getItem('NumberOfInvoices'), 10);
  const UserBeneficiaryDetails = JSON.parse(localStorage.getItem('UserBeneficiaryDetails'));
  const UserInvoice = JSON.parse(localStorage.getItem('UserInvoice'));
  const CreatedKyc = localStorage.getItem('KYCcreated');
  const hasKyc = !!CreatedKyc

  const shouldShowSidebar = [
    '/home',
    '/dashboard',
    '/beneficiaries',
    '/invoices',
    '/transactions',
    '/settings',
  ].includes(location.pathname);

  return (
    <div className="flex w-full overflow-hidden">
      {shouldShowSidebar && (
        <>
          <Sidebar UserProfile={UserProfile} verified={CreatedKyc} />
          <SMSideBar UserProfile={UserProfile} verified={CreatedKyc} />
        </>
      )}
      <div className={`${shouldShowSidebar ? 'lg:ml-[300px]' : ''} w-full`}>
        <div
          className={`w-full top-0 h-[100%] lg:hidden text-[#1D1C1F] z-40 absolute ${sideBar ? 'bg-black/20' : 'hidden'}`}
          onClick={handleSideBar}
        ></div>
        {shouldShowSidebar && <NavBar />}

        {isDataLoaded ? (
          <>
            {showPDFContent &&
              createPortal(
                <ExternalInvoice1 />,
                document.getElementById('pdf-root')
              )}
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<PublicRoute><HomeRoot /></PublicRoute>} />
              <Route path="/about" element={<PublicRoute><AboutUs /></PublicRoute>} />
              <Route path="/how_it_works" element={<PublicRoute><HowItWorks /></PublicRoute>} />
              <Route path="/use_cases" element={<PublicRoute><UseCases /></PublicRoute>} />
              <Route path="/signup" element={<PublicRoute><SignUp /></PublicRoute>} />
              <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
              <Route path="/forgotpassword" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
              <Route path="/validate-otp" element={<PublicRoute><ValidateOTP /></PublicRoute>} />
              <Route path="/reset-password" element={<PublicRoute><UpdatePassword /></PublicRoute>} />

              {/* Protected Routes */}
              <Route element={<ProtectedRoutes />}>
                <Route path="/dashboard/*" element={
                  <RedirectVerifiedUsers isLoading={!isDataLoaded} verified={hasKyc}>
                    <Dashboard />
                  </RedirectVerifiedUsers>
                } />
                <Route path="/home" element={
                  <Home verified={hasKyc} NumberOfBeneficiaryAcct={NumberOfBeneficiaryAcct} UserProfile={UserProfile} NumberOfUserAcct={NumberOfUserAcct} NumberOfInvoices={NumberOfInvoices} UserAcctDetails={UserAcctDetails} />
                } />
                <Route path="/beneficiaries" element={
                  <Beneficiary verified={hasKyc} NumberOfBeneficiaryAcct={NumberOfBeneficiaryAcct} UserBeneficiaryDetails={UserBeneficiaryDetails} />
                } />
                <Route path="/invoices" element={
                  <Invoice verified={hasKyc} NumberOfInvoices={NumberOfInvoices} UserInvoice={UserInvoice} />
                } />
                <Route path="/transactions" element={
                  <Transaction verified={hasKyc} />
                } />
                <Route path="/settings" element={
                  <Settings />
                } />
              </Route>

              <Route path="*" element={<NotFound />} />
            </Routes>
          </>
        ) : (
          <div className="flex justify-center items-center h-screen">
            <LoadingScreen />
          </div>
        )}
      </div>
    </div>
  );

}

export default App;
